import { render, staticRenderFns } from "./settlefrm_idocs.vue?vue&type=template&id=c5835180"
import script from "./settlefrm_idocs.vue?vue&type=script&lang=js"
export * from "./settlefrm_idocs.vue?vue&type=script&lang=js"
import style0 from "./settlefrm_idocs.vue?vue&type=style&index=0&id=c5835180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports